const isPrintableVoucher = (value) => (
    typeof value === "string"
    && !["", "0", "null", "undefined"].includes(value.trim().toLowerCase())
);

const parseJsonValue = (value) => {
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
};

export const resolveOrderVoucher = (order) => {
    if (isPrintableVoucher(order?.voucher_response)) return order.voucher_response;

    const bankVoucher = parseJsonValue(order?.bank_voucher_response);
    const nestedEmvResponse = parseJsonValue(bankVoucher?.EMVStreamResponse);
    const receiptOutput = bankVoucher?.receipt_output || nestedEmvResponse?.receipt_output;
    const receiptVoucher = receiptOutput
        ? `${receiptOutput.customer || ""}${receiptOutput.merchant || ""}`
        : "";
    const fallbackVoucher = bankVoucher?.voucher
        || nestedEmvResponse?.voucher
        || receiptVoucher;

    return isPrintableVoucher(fallbackVoucher) ? fallbackVoucher : "";
};

export const formatVoucherString = (voucher) => {
    const printableVoucher = typeof voucher === "string" ? voucher : String(voucher ?? "");
    return printableVoucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");
};
